module.exports = __webpack_public_path__ + "ae37374686fb31f8ea29b474ea37c4d2.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SE-JAM.svg
// module id = 2pbi
// module chunks = 0